import { BaseError } from "./base-error.js";
export class BadDataError extends BaseError {
    static code = 'BadDataError';
    static statusCode = 400;
    constructor(message = 'Bad Data', options = {}) {
        super(message, options);
    }
}
